var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvailableMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#BCDBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 21H17L14 25.5C13.3 26.5 13 27.7 13 28.9C13 32.3 15.7 35 19.1 35H28.8C32.2 35 34.9 32.3 34.9 28.9C34.9 27.7 34.5 26.5 33.9 25.5L31 21Z",
    stroke: "#3785E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21H34",
    stroke: "#3785E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18C21.1046 18 22 17.1046 22 16C22 14.8954 21.1046 14 20 14C18.8954 14 18 14.8954 18 16C18 17.1046 18.8954 18 20 18Z",
    stroke: "#3785E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18C29.1046 18 30 17.1046 30 16C30 14.8954 29.1046 14 28 14C26.8954 14 26 14.8954 26 16C26 17.1046 26.8954 18 28 18Z",
    stroke: "#3785E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableMoney);
export default __webpack_public_path__ + "static/media/available-money.2ad412cd23e9d4c4c6858b1b5d36c5f6.svg";
export { ForwardRef as ReactComponent };